var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredeeLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.5972C1 10.0546 1.93738 7.73105 3.4854 5.95312L6.57543 9.04315C5.80986 10.0216 5.35355 11.2537 5.35355 12.5924C5.35355 15.776 7.93441 18.3569 11.1181 18.3569C12.4567 18.3569 13.6888 17.9006 14.6673 17.135L17.7667 20.2344C15.9888 21.7825 13.6652 22.7198 11.1227 22.7198C5.53207 22.7198 1 18.1878 1 12.5972Z",
    fill: "#0A6B89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58876 16.157L3.4952 19.2506C1.94134 17.4712 1 15.1432 1 12.5953C1 7.00472 5.53207 2.47266 11.1227 2.47266C13.6705 2.47266 15.9986 3.41399 17.7779 4.96785L14.6843 8.06154C13.7031 7.28794 12.4645 6.82633 11.1181 6.82633C7.93441 6.82633 5.35355 9.40719 5.35355 12.5908C5.35355 13.9373 5.81517 15.1759 6.58876 16.157Z",
    fill: "#FFAD36"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.223,
    cy: 21.179,
    r: 1.77667,
    fill: "#FFAD36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredeeLogo2);
export default __webpack_public_path__ + "static/media/Credee_Logo (2).02368bd024706b40699edc88ac31d72b.svg";
export { ForwardRef as ReactComponent };